import React from "react";
import { TransactionSplitCounterpartyCell } from "@components/transactions/TransactionSplitV2/TransactionSplitCounterpartyCell";
import { BaseCellProps } from "@components/spreadsheet/cells";

export const counterpartyCellFn = (
    counterpartiesMap: Map<string, string>,
): ((props: BaseCellProps) => React.ReactNode) => {
    const renderCell = ({ value, ...rest }: BaseCellProps): React.ReactNode => {
        const stringValue =
            typeof value === "string" || value === null ? value : null;
        return (
            <TransactionSplitCounterpartyCell
                {...rest}
                value={stringValue}
                counterpartiesMap={counterpartiesMap}
            />
        );
    };
    return renderCell;
};
